export const getHttpHandler = async ({
  url,
  headers = { Accept: "application/json", "Content-Type": "application/json" },
  idToken,
}: {
  url: string;
  headers?: any;
  idToken?: string;
}) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { ...headers, Authorization: `Bearer ${idToken}` },
    });
    const responseData = await response.json();
    return responseData;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const postHttpHandler = async ({
  url,
  headers = { Accept: "application/json", "Content-Type": "application/json" },
  idToken,
  body = {},
}: {
  url: string;
  headers?: any;
  body?: any;
  idToken?: string;
}) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { ...headers, Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(body),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const putHttpHandler = async ({
  url,
  headers = { Accept: "application/json", "Content-Type": "application/json" },
  idToken,
  body = {},
}: {
  url: string;
  headers?: any;
  body?: any;
  idToken?: string;
}) => {
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: { ...headers, Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(body),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const deleteHttpHandler = async ({
  url,
  headers = { Accept: "application/json", "Content-Type": "application/json" },
  idToken,
  body = {},
}: {
  url: string;
  headers?: any;
  body?: any;
  idToken?: string;
}) => {
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: { ...headers, Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(body),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error: any) {
    throw new Error(error);
  }
};
